/*
 * 1-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * colours.js - Colour scheme for app
 */

export const logoBackground = '#263567';

// Category Colours
// export const subitising = '#FF7A68';
// export const subitisingButton = '#F8BDB2';
export const subitising = '#FFE157';
export const subitisingButton = '#FFFFBE';
export const addition = '#56B8C2';
export const additionButton = '#B9DDE2';
export const subtraction = '#FF5470';
export const subtractionButton = '#E9A5B6';
export const multiplication = '#B4DD63';
export const multiplicationButton = '#DDE9B9';
export const division = '#8B8FC7';
export const divisionButton = '#DFDFFA';

// Topic Colours
export const topic1 = '#E63323';
export const topic2 = '#F18700';
export const topic3 = '#82BC45';
export const topic4 = '#00b0ea';
export const topic5 = '#6555a0';
export const topic6 = '#ec69a4';
export const topic7 = '#8B8FC7';
export const topic8 = '#28A737';
export const topic9 = '#E7355F';
export const topic10 = '#00B2BD';
export const topic11 = '#E49F00';
export const topic12 = '#E4007E';
export const topic13 = '#732380';
export const topic14 = '#E64E51';
export const topic15 = '#0067B2';
export const topic16 = '#509136';
export const topic17 = '#C18733';
export const topic18 = '#CC5299';
export const topic19 = '#067DA1';

export const grey = '#d9d9d9';
export const darkGrey = '#a9a9a9';
export const darkGreen = '#5af34e';
export const confirm = '#00ba00';
export const backspace = '#ba0000';

export const red = '#ec536f';
export const red2 = '#F44336';
export const pink = '#E91E63';
export const purple = '#9C27B0';
export const deepPurple = '#673AB7';
export const indigo = '#3F51B5';
export const blue = '#2196F3';
export const lightBlue = '#03A9F4';
export const cyan = '#00BCD4';
export const teal = '#009688';
export const green = '#4CAF50';
export const lightGreen = '#8BC34A';
export const lime = '#CDDC39';
export const yellow = '#FFEB3B';
export const amber = '#FFC107';
export const orange = '#FF9800';
export const deepOrange = '#FF5722';
export const disabledGreen = '#4CAF5044';
export const disabledBlue = '#2196F344';

export const colourArray = [
  red,
  red2,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
];

export const numColours = colourArray.length;
